import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'punchlineTextarea',
        'saveButton',
        'errorContainer',
        'characterCounter',
    ];

    openModal(data) {
        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });

        this.punchlineTextareaTarget.value = data.trim();
        this.punchlineTextareaTarget.dispatchEvent(new Event('input'));
    }

    updateCounter() {
        const length = this.punchlineTextareaTarget.value.length;
        this.characterCounterTarget.textContent = length;

        if (length > 230) {
            this.characterCounterTarget.classList.add('text-danger');
            this.saveButtonTarget.disabled = true;
            this.errorContainerTarget.style.display = 'block';
        } else {
            this.characterCounterTarget.classList.remove('text-danger');
            this.saveButtonTarget.disabled = false;
            this.errorContainerTarget.style.display = 'none';
        }
    }

    save() {
        showPreloader();

        $.ajax({
            url: routes['app_profile_punchlinefieldupdate'],
            method: 'POST',
            data: { punchline: this.punchlineTextareaTarget.value },
            success: (response) => {
                if (response.status) {
                    $(this.element).modal('hide');

                    $('#punchline-textarea-readonly').html(response.punchline);

                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'profile_punchline_update',
                            'label': '-',
                        },
                    });

                    window.location.reload();
                } else {
                    hidePreloader();
                    addAlert('danger', translations['profile.Max length error punchline']);
                }
            },
            error: function(error) {
                const json = error.responseJSON;

                if (json && json.message) {
                    addAlert('danger', json.message);
                    hidePreloader();

                    return;
                }
                addAlert('danger', translations['profile.An unknown error occurred.']);
                hidePreloader();
            },
        });
    }
}
